import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';

export default class PlannerReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: moment().startOf('day').toDate(),
            endDate: moment().endOf('day').toDate(),
            isLoading: false,
            plannerReportData: [],
            selectedPlannerShifts: [],
            plannerShifts: [
                { label: 'Morning - 6:00am to 12:30pm', value: 1 },
                { label: 'Noon - 12:30pm to 5:30pm', value: 2 },
                { label: 'Evening - 5:30pm to 6:00am', value: 3 }
            ],
            dateList: [],
            downloadableCsvDataPlannerReports: '',
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handlePlannerShiftSelection = this.handlePlannerShiftSelection.bind(this);
        this.handlePlannerReportGeneration = this.handlePlannerReportGeneration.bind(this);
    }

    handleStartDateChange(date) {
        this.setState({ startDate: date });
    }

    handleEndDateChange(date) {
        this.setState({ endDate: date });
    }

    handlePlannerShiftSelection(selectedPlannerShifts) {
        this.setState({ selectedPlannerShifts });
    }

    async handlePlannerReportGeneration(e) {
        e.preventDefault();
        this.setState({ isLoading: true });
        const { selectedPlannerShifts, startDate, endDate } = this.state;
        const url = '/api/v1/portal/portal-admin/planner-report';
        try {
            const response = await fetch(url, {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Authorization": 'Bearer ' + (window.api_token || ''),
                    "Accept": 'application/json',
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    selected_planner_shifts: selectedPlannerShifts,
                    start_date: moment(startDate).format("YYYY-MM-DD"),
                    end_date: moment(endDate).format("YYYY-MM-DD"),
                }),
            });
            const data = await response.json();
            const dateList = this.getDatesInRange(startDate, endDate);
            const plannersData = this.generatePlannerData(data, dateList);
            const downloadableCsvDataPlannerReports = this.generateCsvData(plannersData, dateList);
            this.setState({ plannerReportData: data, dateList, downloadableCsvDataPlannerReports, isLoading: false });
        } catch (error) {
            console.error('Error generating report:', error);
            this.setState({ isLoading: false });
        }
    }

    download(filename, text) {
        const formattedFilename = `${filename} From ${moment(this.state.startDate).format("YYYY-MM-DD")} To ${moment(this.state.endDate).format("YYYY-MM-DD")}.csv`;
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', formattedFilename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    getDatesInRange(start, end) {
        const dates = [];
        let currentDate = moment(start);
        while (currentDate <= moment(end)) {
            dates.push(currentDate.format('DD/MM/YYYY'));
            currentDate.add(1, 'days');
        }
        return dates;
    }

    generatePlannerData(data, dateList) {
        if (!Array.isArray(data)) {
            return [];
        }

        return data.map(planner => {
            const { planner_name, data } = planner || {};
            const total_jobs_planned = data ? Object.values(data).reduce((sum, count) => sum + (count || 0), 0) : 0;

            return {
                planner_name: planner_name || 'Unknown',
                total_jobs_planned,
                dates: dateList.map(date => (data && data[date]) || 0)
            };
        });
    }

    generateCsvData(plannersData, dateList) {
        const csvHeaders = ["Planner Name", "Total Jobs Planned", ...dateList];
        const csvRows = plannersData.map(planner => {
            const { planner_name, total_jobs_planned, dates } = planner || {};
            return [planner_name, total_jobs_planned, ...dates].join(',');
        });

        return [csvHeaders.join(','), ...csvRows].join('\n');
    }

    renderTableHeaders(dateList) {
        return [
            <th key="planner_name">Planner Name</th>,
            <th key="total_jobs_planned">Total Jobs Planned</th>,
            ...dateList.map((date, index) => <th key={index}>{date}</th>)
        ];
    }

    renderTableRows(plannersData) {
        return plannersData.map((planner, index) => {
            const { planner_name, total_jobs_planned, dates } = planner || {};
            const dateCells = dates.map((count, dateIndex) => <td key={dateIndex}>{count}</td>);

            return (
                <tr key={index}>
                    <td>{planner_name}</td>
                    <td>{total_jobs_planned}</td>
                    {dateCells}
                </tr>
            );
        });
    }

    render() {
        const { selectedPlannerShifts, plannerShifts, isLoading, startDate, endDate, plannerReportData, dateList, downloadableCsvDataPlannerReports } = this.state;
        const plannersData = this.generatePlannerData(plannerReportData, dateList);

        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Planner Work Report</h2>
                    <br />
                </div>
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br />
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={startDate} />
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br />
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={endDate} />
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Planner Shift</h5></label><br />
                        <div>
                            <StatefulMultiSelect
                                options={plannerShifts}
                                selected={selectedPlannerShifts}
                                onSelectedChanged={this.handlePlannerShiftSelection}
                                overrideStrings={{
                                    selectSomeItems: "Select Shifts...",
                                    allItemsAreSelected: "All Shifts are Selected",
                                    selectAll: "Select All",
                                    search: "Search Shift",
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={this.handlePlannerReportGeneration}>
                                <i className="fa fa-save"></i> Generate Planner Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin" onClick={() => this.download('Planner Report', downloadableCsvDataPlannerReports)}>
                                <i className="fa fa-download"></i> Download Planner Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{plannerReportData.length} Report found..</b></label></div>
                </div>
                {dateList.length > 0 && (
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="planner-report-tbl-scroll">
                                <table className="planner-report-tbl no-footer">
                                    <thead>
                                        <tr>
                                            {this.renderTableHeaders(dateList)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading ?
                                            (<tr><td colSpan={dateList.length + 2}><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                            plannersData.length > 0 ? this.renderTableRows(plannersData) : (
                                                <tr><td colSpan={dateList.length + 2} className='text-center'>No Records</td></tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <br /><br /><br />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

PlannerReport.propTypes = {
    message_if_none: PropTypes.string
};

if (document.getElementById('react-component-g4-logistics-portal-planner_report')) {
    ReactDOM.render(
        <PlannerReport message_if_none='Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-planner_report')
    );
}
